module.exports = __webpack_public_path__ + "img/aidt.b95de372.jpg";